import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';
import { MocksHelper } from './mocks/MocksHelper';
import SaldoMockService from './mocks/SaldoMockService';

// eslint-disable-next-line react-hooks/rules-of-hooks
const mocked = MocksHelper.useMocks();
const SaldoService = {
  retrieveSaldo: (data: object) =>
    trackPromise(
      api.post(
        `/rest/misaldo/${i18next.language}/get/page/info`,
        JSON.stringify(data),
      ),
    ),
};
export default mocked ? SaldoMockService : SaldoService;
